import React from 'react';
import { connect } from 'react-redux';
import Confirm from 'react-confirm-bootstrap';
import { userActions } from '../_actions';

class ConfirmDeleteAccount extends React.Component {

  onConfirm(user) {
    // Preform your action.
    console.log("What is this?", user);

    const { dispatch } = this.props;

      dispatch(userActions.deleteAccount(user._id));

  }
  render() {
    const {user} = this.props;
    return (
      <Confirm
        onConfirm={(e) => this.onConfirm(user)}
        body="Are you sure you want to delete your Fix-a-Drink account?"
        confirmText="Confirm Account Deletion"
        title="Deleting Account">
        <button>Delete My Account</button>
      </Confirm>
    )
  }
}

const connectedDeleteAccount = connect(null)(ConfirmDeleteAccount);
export { connectedDeleteAccount as ConfirmDeleteAccount };


// WEBPACK FOOTER //
// ./src/ConfirmDeleteAccount/ConfirmDeleteAccount.jsx